module.exports = __webpack_public_path__ + "img/device_1012_2_select.6694cbce.svg";